"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/ToggleSelector/index.ts
var ToggleSelector_exports = {};
__export(ToggleSelector_exports, {
  ToggleButton: () => ToggleButton,
  ToggleSelector: () => ToggleSelector,
  ToggleSelectorShape: () => ToggleSelectorShape
});
module.exports = __toCommonJS(ToggleSelector_exports);

// src/components/ToggleSelector/ToggleButton.tsx
var import_react2 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));

// src/components/ToggleSelector/ToggleSelector.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var ToggleSelectorShape = /* @__PURE__ */ ((ToggleSelectorShape2) => {
  ToggleSelectorShape2["Rounded"] = "rounded";
  ToggleSelectorShape2["Rectangle"] = "rectangle";
  ToggleSelectorShape2["RoundedMd"] = "rounded-md";
  return ToggleSelectorShape2;
})(ToggleSelectorShape || {});
var sizeClasses = {
  DEFAULT: "v2-font-bold v2-border v2-font-circular",
  sm: "v2-py-[5px] v2-px-2.5 v2-text-xs",
  md: "v2-py-0 v2-px-[15px] v2-text-[16px] v2-h-[40px]",
  lg: "v2-py-2.5 v2-px-[15px] v2-text-base",
  xl: "v2-py-2.5 v2-px-[15px] v2-text-lg"
};
function ToggleSelector({
  items,
  selected,
  selectedTextColorClassName,
  size,
  notSelectedBgColorClassName,
  className,
  buttonClassName,
  activeButtonClassName,
  disabled,
  shape = "rounded" /* Rounded */,
  onSelect,
  textColorClassName,
  borderColorClassName,
  textHoverColorClassName,
  buttonBorderColorClassName
}) {
  const sizeClass = (0, import_react.useMemo)(() => {
    if (size === "sm") {
      return sizeClasses["sm"];
    }
    if (size === "md") {
      return sizeClasses["md"];
    }
    if (size === "lg") {
      return sizeClasses["lg"];
    }
    if (size === "xl") {
      return sizeClasses["xl"];
    }
    return sizeClasses["sm"];
  }, [size]);
  const itemComponents = (0, import_react.useMemo)(() => {
    const components = [];
    if (items) {
      for (const key in items) {
        components.push(
          /* @__PURE__ */ import_react.default.createElement(
            ToggleButton,
            {
              key,
              id: key,
              disabled,
              sizeClass,
              label: items[key],
              selected: selected === key,
              selectedTextColorClassName,
              notSelectedBgColorClassName,
              onClick: () => onSelect == null ? void 0 : onSelect(key),
              className: buttonClassName,
              activeClassName: activeButtonClassName,
              shape,
              textColorClassName,
              textHoverColorClassName,
              buttonBorderColorClassName
            }
          )
        );
      }
      return components;
    }
  }, [
    items,
    shape,
    selected,
    selectedTextColorClassName,
    sizeClass,
    notSelectedBgColorClassName,
    selectedTextColorClassName,
    textColorClassName,
    textHoverColorClassName,
    buttonBorderColorClassName
  ]);
  return /* @__PURE__ */ import_react.default.createElement(
    "div",
    {
      className: (0, import_classnames.default)(
        className,
        "toggle-selector",
        [
          "v2-flex v2-text-center v2-border v2-border-solid",
          "v2-w-full",
          `${borderColorClassName != null ? borderColorClassName : "v2-border-neutral-300"}`
        ],
        {
          "v2-rounded-full": shape === "rounded" /* Rounded */,
          "v2-rounded-none": shape === "rectangle" /* Rectangle */,
          "v2-rounded-md": shape === "rounded-md" /* RoundedMd */
        }
      )
    },
    itemComponents
  );
}

// src/components/ToggleSelector/ToggleButton.tsx
var ToggleButton = ({
  id,
  className,
  activeClassName,
  selected,
  selectedTextColorClassName,
  notSelectedBgColorClassName,
  sizeClass,
  disabled,
  label,
  shape,
  textColorClassName,
  textHoverColorClassName,
  buttonBorderColorClassName,
  onClick
}) => {
  return /* @__PURE__ */ import_react2.default.createElement(
    "button",
    {
      id: id && `toggle-button-value-${id}`,
      className: (0, import_classnames2.default)(
        className,
        sizeClass,
        textColorClassName,
        "toggle-selector-button v2-flex-1  v2-truncate",
        `${buttonBorderColorClassName ? `v2-border ${buttonBorderColorClassName}` : ""}`,
        {
          [`v2-bg-yellow-300 ${activeClassName != null ? activeClassName : ""}`]: selected,
          [`${selectedTextColorClassName != null ? selectedTextColorClassName : ""}`]: selected,
          [`${notSelectedBgColorClassName != null ? notSelectedBgColorClassName : ""}`]: !selected,
          "v2-bg-neutral-100": disabled,
          "hover:v2-bg-yellow-100": !selected && !disabled,
          [`hover:${textHoverColorClassName != null ? textHoverColorClassName : ""}`]: !disabled,
          "v2-rounded-full": shape === "rounded" /* Rounded */,
          "v2-rounded-none": shape === "rectangle" /* Rectangle */,
          "v2-rounded-md": shape === "rounded-md" /* RoundedMd */
        }
      ),
      onClick,
      disabled
    },
    label
  );
};
